import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

export const clubRouteElements = [
  {
    segment: 'benefits-club',
    element: lazyModulePage('club', () => import('@/soluqr/modules/club/screens/BenefitsClubPage')),
  },
  {
    segment: 'broadcast',
    element: lazyModulePage('club', () => import('@/soluqr/modules/club/screens/BroadcastPage')),
  },
  {
    segment: 'team',
    element: lazyModulePage('club', () => import('@/soluqr/modules/club/screens/TeamPage')),
  },
];
